import { render, staticRenderFns } from "./couponSettingCommodity.vue?vue&type=template&id=2d69bf96&scoped=true&"
import script from "./couponSettingCommodity.vue?vue&type=script&lang=js&"
export * from "./couponSettingCommodity.vue?vue&type=script&lang=js&"
import style0 from "./couponSettingCommodity.vue?vue&type=style&index=0&id=2d69bf96&scoped=true&lang=css&"
import style1 from "./couponSettingCommodity.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d69bf96",
  null
  
)

export default component.exports